<!-- View for assistant for searching funeral homes -->
<template>
	<div class="flex place-content-between bg-white p-4">
		<Search />
		<Locations />
	</div>
</template>

<script setup lang="ts">
import Locations from './Locations.vue'
import Search from './Search.vue'
</script>
